import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-full relative z-30 vue-slider" }
const _hoisted_2 = {
  class: /*#__PURE__*/_normalizeClass(['vue-slider-mark-label', 'custom-label'])
}
const _hoisted_3 = { class: "relative flex h-16 justify-between divide divide-x divide-brand-light" }
const _hoisted_4 = ["onClick", "src", "srcset", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueSlider = _resolveComponent("VueSlider")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["relative z-0 w-full font-light", { 'px-4': _ctx.details === true }]),
    onMouseover: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleDetails(true))),
    onMouseout: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleDetails(false)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_VueSlider, {
        modelValue: _ctx.selectedValues,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedValues) = $event)),
        adsorb: true,
        data: _ctx.sliderData,
        lazy: true,
        tooltip: false,
        processStyle: _ctx.sliderProcessStyle,
        dotStyle: _ctx.sliderDotStyle,
        railStyle: _ctx.sliderRailStyle,
        stepStyle: _ctx.sliderStepStyle,
        stepActiveStyle: _ctx.sliderStepActiveStyle
      }, {
        label: _withCtx(({ label }) => [
          _createElementVNode("div", _hoisted_2, _toDisplayString(label), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "data", "processStyle", "dotStyle", "railStyle", "stepStyle", "stepActiveStyle"])
    ]),
    (_ctx.show && _ctx.allowedDetails.includes(_ctx.filterId))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["absolute -top-14 bg-white h-28 z-10 -ml-6 sm:-ml-7 overflow-hidden w-p105 sm:w-p115", { 'shadow-md hover-box': _ctx.details !== true }])
        }, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.values, (valueText, valueIdx) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "flex-1 grid justify-items-center",
                key: 'value' + valueIdx
              }, [
                _createElementVNode("img", {
                  onClick: ($event: any) => (_ctx.toggleValue(valueIdx)),
                  src: 
              _ctx.Images.get(
                '/img/filter/' +
                  _ctx.filterId +
                  '/' +
                  valueIdx.toUpperCase() +
                  '@1x.jpg'
              )
            ,
                  srcset: 
              _ctx.Images.get(
                '/img/filter/' +
                  _ctx.filterId +
                  '/' +
                  valueIdx.toUpperCase() +
                  '@2x.jpg'
              )
            ,
                  alt: valueText,
                  class: _normalizeClass(["relative mt-1 inline-block w-full max-h-12", {
              'opacity-20':
                Object.values(_ctx.values).indexOf(valueIdx) < _ctx.selectedValues[0] ||
                Object.values(_ctx.values).indexOf(valueIdx) > _ctx.selectedValues[1],
            }]),
                  style: {"max-width":"3rem"}
                }, null, 10, _hoisted_4)
              ]))
            }), 128))
          ])
        ], 2))
      : _createCommentVNode("", true)
  ], 34))
}